import { render, staticRenderFns } from "./Project720.vue?vue&type=template&id=260813b0&scoped=true"
import script from "./Project720.vue?vue&type=script&lang=js"
export * from "./Project720.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260813b0",
  null
  
)

export default component.exports